/** @format */

import names from './names.json';

type fieldNames = {
  [key: string]: string | undefined;
};

export const fieldName = (techName: string): string => {
  return (names as fieldNames)[techName] || '';
};
